// extracted by mini-css-extract-plugin
module.exports = {"plus-more-counter":"PortalTooltipColumn_plus-more-counter__t5cpK"};